'use client'

import { INoticeEvent } from '@/api/interfaces/INoticeEvent'
import { createT } from '@/locales/index'
import { WithT } from '@/locales/types'
import { fromNow } from '@/util/datetime'
import Image from 'next/image'
import Link from 'next/link'

type Props = {
  notice: INoticeEvent.INotice.INoticeR
}

export function NoticeRow({ notice, translations }: WithT<Props>) {
  const t = createT(translations)

  return (
    <Link
      href={`/notice/${notice.id}`}
      className="flex items-center gap-2 py-4"
    >
      <div className="flex flex-col gap-1.5 flex-1">
        <div className="text-body3 font-bold text-gray-600">
          <span>{t('notice')}</span>
        </div>
        <p className="text-body2 font-bold">{notice.title}</p>
        <div className="text-body3 text-gray-600" suppressHydrationWarning>
          {fromNow(notice.createDate, translations)}
        </div>
      </div>
      {notice.thumbnailUrl && (
        <Image
          src={notice.thumbnailUrl}
          alt={notice.title}
          width={100}
          height={60}
          className="h-[3.75rem] rounded object-cover"
        />
      )}
    </Link>
  )
}
